
<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <v-card>
      <v-card-text>
        <filterComponents
          @doFilter="setFilter"
        />
      </v-card-text>
    </v-card>
    <v-card>
      <v-card-title>
        {{ $t('invoices.invoices') }}
        <v-spacer />
      </v-card-title>
      <v-data-table
        :loading="dataLoading"
        :headers="headers"
        :search="search"
        :items="list"
        :items-per-page="20"
        :footer-props="{
          'items-per-page-options': [10, 20, 30, 40, 50]
        }"
        :options.sync="options"
        :server-items-length="total"
        :page-count="numberOfPages"
        @fetchAllItems="fetchAllItems"
      >
        <template v-slot:[`item.paymentStatus`]="{ item }">
          <v-chip
            v-if="item.payment_status === 1"
            color="success"
            text-color="white"
          >
            Completed
          </v-chip>
          <v-chip
            v-else
            color="red"
            text-color="white"
          >
            UnCompleted
          </v-chip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip
            bottom
          >
            <template
              v-slot:activator="{ on, attrs }"
            >
              <v-btn
                small
                fab
                outlined
                class="mx-2"
                color="blue"
                v-bind="attrs"
                v-on="on"
                @click="openinvoice(item)"
              >
                <v-icon>
                  mdi-eye
                </v-icon>
              </v-btn>
            </template>
            {{ $t('actions.view') }}
          </v-tooltip>
          <v-tooltip
            bottom
          >
            <template
              v-slot:activator="{ on, attrs }"
            >
              <v-btn
                small
                fab
                outlined
                class="mx-2"
                color="success"
                v-bind="attrs"
                v-on="on"
                @click="generateReport(item)"
              >
                <v-icon>
                  fa-print
                </v-icon>
              </v-btn>
            </template>
            {{ $t('actions.print') }}
          </v-tooltip>
        </template>

        <template
          v-slot:no-data
          loading
        >
          <p>{{ $t('actions.noData') }}</p>
        </template>
      </v-data-table>
      <template>
        <div>
          <vue-html2pdf
            ref="html2Pdf"
            :show-layout="false"
            :float-layout="true"
            :enable-download="true"
            :preview-modal="false"
            :paginate-elements-by-height="1400"
            filename="فاتورة"
            :pdf-quality="2"
            :manual-pagination="true"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="100%"
            @progress="onProgressPdf($event)"
          >
            <invoice
              slot="pdf-content"
              :item-details="itemDetails"
            />
          </vue-html2pdf>
          <custom-progress
            v-show="showProgress"
            :progress="progressNumber"
          />
        </div>
      </template>
    </v-card>
    <v-snackbar
      v-model="successSnackbar"
      color="success"
      shaped
      bottom
      right
      :timeout="timeout"
    >
      {{ successMessage }}
    </v-snackbar>
    <v-snackbar
      v-model="errorSnackbar"
      color="red"
      shaped
      bottom
      right
      :timeout="timeout"
    >
      {{ errorMessage }}
    </v-snackbar>
    <v-dialog
      v-model="invoiceDialog"
      width="850"
    >
      <v-card>
        <v-card-text>
          <invoice :item-details="itemDetails" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import filterComponents from './filter.vue'
  import invoice from './invoice.vue'
  import VueHtml2pdf from 'vue-html2pdf'
  import CustomProgress from '../../component/progress.vue'
  import { mapActions } from 'vuex'
  import { ServiceFactory } from '@/services/ServiceFactory'
  const invoicesService = ServiceFactory.get('invoices')
  export default {
    name: 'Companies',
    components: {
      filterComponents,
      VueHtml2pdf,
      CustomProgress,
      invoice,
    },
    data: (vm) => ({
      search: '',
      dataLoading: false,
      page: 0,
      total: 0,
      numberOfPages: 0,
      options: {},
      list: [],
      filter: {
        client_name: null,
        receipt_number: null,
        date_from: null,
        date_to: null,
      },
      loading: false,
      deleteDailog: false,
      changeStatusDailog: false,
      invoiceDialog: false,
      itemDetails: {},
      editedIndex: -1,
      successSnackbar: false,
      errorSnackbar: false,
      timeout: 3000,
      successMessage: '',
      errorMessage: '',
      disabled: false,
      headers: [
        {
          text: vm.$t('invoices.id'),
          align: 'start',
          sortable: false,
          value: 'id',
        },
        { text: vm.$t('invoices.date'), sortable: false, value: 'receipt_date' },
        { text: vm.$t('invoices.invoiceNumber'), sortable: false, value: 'receipt_number' },
        { text: vm.$t('invoices.clientName'), sortable: false, value: 'client.name' },
        { text: vm.$t('invoices.invoiceTotal'), sortable: false, value: 'total_egp' },
        { text: vm.$t('invoices.paymentStatus'), sortable: false, value: 'paymentStatus' },
        { text: vm.$t('actions.actions'), value: 'actions', sortable: false },
      ],
      progressNumber: 0,
      showProgress: false,
      pdfDataLoading: false,
    }),
    watch: {
      options: {
        handler () {
          this.fetchAllItems()
        },
      },
    },
    methods: {
      openinvoice (item) {
        this.itemDetails = {}
        this.invoiceDialog = true
        this.itemDetails = item
        console.log('this.itemDetails', this.itemDetails)
      },
      onProgressPdf: function (data) {
        this.progressNumber = data
        if (data === 100) {
          setTimeout(() => {
            this.showProgress = false
          }, 1000)
        }
      },
      generateReport: async function (item) {
        this.progressNumber = 0
        this.pdfDataLoading = true
        this.showProgress = true
        this.progressNumber = 40
        this.progressNumber = 40
        this.itemDetails = item
        if (this.itemDetails) {
          this.progressNumber = 20
          await this.$refs.html2Pdf.generatePdf()
          console.log('this.itemDetails', this.itemDetails)
          this.successMessage = 'تمت تحميل الملف بنجاح'
          this.successSnackbar = true
        } else {
          this.errorMessage = 'يوجد مشكلة في تحميل الملف برجاء المحاولة مرة اخري'
          this.errorSnackbar = true
        }
      },
      setFilter (value) {
        console.log('value :>> ', value)
        this.filter = value
        this.fetchAllItems()
      },
      async fetchAllItems () {
        this.dataLoading = true
        const { page, itemsPerPage } = this.options
        const pageNumber = page - 1
        const list = await invoicesService.getAllItems(itemsPerPage, page, pageNumber, this.filter)
        this.list = list.data
        this.total = list.total
        // this.numberOfPages = companies.data.pageCount
        this.dataLoading = false
      },
      confirmDeleteItem (data) {
        this.itemDetails = data
        this.deleteDailog = true
      },
      ...mapActions([
        'storeEmployee',
      ]),
      editItem (item) {
        this.storeEmployee(item)
        this.$router.push('/settings/employeesForm/' + item.id)
      },
      async deleteItem (itemDetails) {
        this.loading = true
        this.disabled = true
        const deleteItem = await invoicesService.deleteItem(itemDetails.id)
        if (deleteItem.status === 'success') {
          this.deleteDailog = false
          this.successMessage = 'Item Is Deleted Successfuly'
          this.successSnackbar = true
          setTimeout(() => {
            this.editedIndex = this.list.indexOf(itemDetails)
            this.list.splice(this.editedIndex, 1)
          }, 500)
        } else {
          this.errorMessage('something Error')
          this.errorSnackbar = true
        }
        this.disabled = false
        this.loading = false
      },
      confirmChangeStatus (item) {
        this.itemDetails = item
        this.changeStatusDailog = true
      },
      async changeStatus (itemDetails) {
        this.loading = true
        this.disabled = true
        const changeStatus = await invoicesService.changeStatus(itemDetails)
        if (changeStatus.status === 'success') {
          this.changeStatusDailog = false
          this.successMessage = 'Item Is changed his Status Successfuly'
          this.successSnackbar = true
          setTimeout(() => {
            if (itemDetails.is_active === 'inactive') {
              itemDetails.is_active = 'active'
            } else {
              itemDetails.is_active = 'inactive'
            }
          }, 500)
        } else {
          this.errorMessage('something Error')
          this.errorSnackbar = true
        }
        this.disabled = false
        this.loading = false
      },
    },
  }
</script>
<style>
a{
  text-decoration: none;
}
</style>
